import { configureStore } from '@reduxjs/toolkit';
import throttle from 'lodash/throttle';
import customizationReducer from './customizationReducer';
import appReducer from './appReducer';

const store = configureStore({
  reducer: {
    customization: customizationReducer,
    application: appReducer,
  },
});

function saveToLocalStorage(state) {
  try {
    const userDetails = state.application.user;
    const renewalNotifications = state.application.renewalNotifications;
    const paymentNotifications = state.application.paymentNotifications;
    const otherNotifications = state.application.otherNotifications;
    const customers = state.application.customers;
    const suspendedProperties = state.application.suspendedProperties;
    const organizations = state.application.organizations;
    const selectedOrganization = state.application.selectedOrganization;
    const expiredSubscribers = state.application.expiredSubscribers;
    
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_user_session', JSON.stringify(userDetails));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_renewal_notifications', JSON.stringify(renewalNotifications));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_payment_notifications', JSON.stringify(paymentNotifications));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_other_notifications', JSON.stringify(otherNotifications));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_customers', JSON.stringify(customers));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_suspended_properties', suspendedProperties);
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_organizations', JSON.stringify(organizations));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_selected_organization', JSON.stringify(selectedOrganization));
    window.localStorage.setItem(process.env.REACT_APP_NAME+'_expired_subscribers', expiredSubscribers);
  } catch (e) {
    console.error('Error saving to localStorage:', e);
  }
}

// Throttle the save function to once per second to avoid excessive writes
store.subscribe(throttle(() => saveToLocalStorage(store.getState()), 1000));

export default store;
